import { CareerPageForm } from 'components/Form/CareerPageForm';
import FormSection from '..';
import CareerFormSidebar from '../Sidebars/Career';

const CareerForm = () => (
    <FormSection sidebar={<CareerFormSidebar />}>
        <CareerPageForm />
    </FormSection>
);

export default CareerForm;
